import {
  WEB_PUSH_INSTALL_INTENT_STORAGE_KEY,
  WEB_PUSH_INSTALL_INTENT_TTL_MS,
  webPushInstallIntentSchema,
} from "@/lib/webPushInstallIntent";

/** Reads one unexpired, browser-level Web Push install return intent. */
export function readWebPushInstallIntent() {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.localStorage.getItem(WEB_PUSH_INSTALL_INTENT_STORAGE_KEY);
    const parsed = raw ? webPushInstallIntentSchema.safeParse(JSON.parse(raw)) : null;
    if (parsed?.success && parsed.data.requestedAt + WEB_PUSH_INSTALL_INTENT_TTL_MS > Date.now()) {
      return parsed.data;
    }

    if (raw) window.localStorage.removeItem(WEB_PUSH_INSTALL_INTENT_STORAGE_KEY);
    return null;
  } catch {
    return null;
  }
}
